import { OperacaoFormularioBusca, OperacaoFormularioCRUD } from "../../service/restricao/OperacaoFormulario/OperacaoFormulario"
import { RestricaoCampoFormulario } from "../../service/restricao/RestricaoCampoFormulario"

/**********************
  Permissões genéricas
 **********************/
export const SemAcesso: RestricaoCampoFormulario = { hidden: true };
export const SemRestricao: RestricaoCampoFormulario = { };
export const SomenteVisualizacao: RestricaoCampoFormulario = { readOnly: true };
  
export const BuscaSemAcesso = { [OperacaoFormularioBusca.Buscar]: SemAcesso };
export const BuscaSemRestricao = { [OperacaoFormularioBusca.Buscar]: SemRestricao };
export const BuscaSomenteVisualizacao = { [OperacaoFormularioBusca.Buscar]: SomenteVisualizacao };


export const CRUDSemAcesso = {
  [OperacaoFormularioCRUD.Visualizar]: SemAcesso,
  [OperacaoFormularioCRUD.Criar]: SemAcesso,
  [OperacaoFormularioCRUD.Atualizar]: SemAcesso,
};
export const CRUDSemRestricao = {
  [OperacaoFormularioCRUD.Visualizar]: SomenteVisualizacao,
  [OperacaoFormularioCRUD.Criar]: SemRestricao,
  [OperacaoFormularioCRUD.Atualizar]: SemRestricao,
};
export const CRUDSomenteVisualizacao = {
  [OperacaoFormularioCRUD.Visualizar]: SomenteVisualizacao,
  [OperacaoFormularioCRUD.Criar]: SomenteVisualizacao,
  [OperacaoFormularioCRUD.Atualizar]: SomenteVisualizacao,
};